export const COVER_DOWNLOAD_MAX_BYTES = 2_000_000;

export function coverDownloadFileName(clipName: string | null | undefined, suffix: string): string {
  const cleaned = (clipName ?? '')
    // eslint-disable-next-line no-control-regex
    .replace(/[/\\:*?"<>|\u0000-\u001f\u007f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .trim();
  const base = Array.from(cleaned).slice(0, 80).join('').trim();
  return `${base || 'clip'} - ${suffix}.jpg`;
}

export function needsCoverReencode({ type, size }: { type: string; size: number }): boolean {
  return !(type === 'image/jpeg' && size <= COVER_DOWNLOAD_MAX_BYTES);
}

export function coverEncodeLadder({
  width,
  height,
}: {
  width: number;
  height: number;
}): Array<{ width: number; height: number; quality: number }> {
  const attempts = [0.92, 0.85, 0.75, 0.65].map((quality) => ({ width, height, quality }));
  for (let k = 1; k <= 6; k++) {
    const f = Math.pow(0.85, k);
    attempts.push({ width: Math.round(width * f), height: Math.round(height * f), quality: 0.8 });
  }
  return attempts;
}
